import jQuery from 'jquery';

// strange workaround, because the expose loader simply stopped working

window.$ = jQuery;
window.jQuery = jQuery;

export default jQuery;
